import React, { Component } from 'react';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import Compliance2PageUI from './Compliance2PageUI';
import { withRouter } from 'react-router-dom';
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";


class Compliance2PageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      complianceList: null,
      filteredList: null,
      selectedFilter: 'all',
      accountList: [],
      selectedStatus: 'all',
      searchFilter: '',
      penaltyList: null,
      penalties: null,
      totalDefaultInterest: null,
      totalDefaultInterestTax: null,
      totalDefaultInterestPlusTax: null,
      totalDsraDipInterest: null,
      downloadSubmitted: false,
      sendingInternalEmail: false
    };
  }

  render() {
    return (
      <Compliance2PageUI
        context={this.props.context}
        errorList={this.state.errorList}
        complianceList={this.state.filteredList}
        yearMonth={this.state.yearMonth}
        onRefreshClick={this.onRefreshClick}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        selectedFilter={this.state.selectedFilter}
        onFilterChange={this.onFilterChange}
        selectedStatus={this.state.selectedStatus}
        onStatusChange={this.onStatusChange}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onDownloadComplianceReport={this.onDownloadComplianceReport}
        penaltyList={this.state.penaltyList}
        penalties={this.state.penalties}
        totalDefaultInterest={this.state.totalDefaultInterest}
        totalDefaultInterestTax={this.state.totalDefaultInterestTax}
        totalDefaultInterestPlusTax={this.state.totalDefaultInterestPlusTax}
        totalDsraDipInterest={this.state.totalDsraDipInterest}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context;
    this.getNonCompliances(context, '', '');
    this.getPenalties(context)
  }

  componentDidUpdate(prevProps) {
    const { year, month } = this.props.match.params;
    if (year !== prevProps.match.params.year || month !== prevProps.match.params.month) {
      this.getNonCompliances(this.props.context);
      this.getPenalties(this.props.context)
    }
  }

  onPreviousClick = () => {
    let context = this.props.context
    this.getNonCompliances(context, this.state.previousYear, this.state.previousMonth)
  }

  onNextClick = () => {
    let context = this.props.context
    this.getNonCompliances(context, this.state.nextYear, this.state.nextMonth)
  }

  getNonCompliances(context, year, month) {
    year = year === undefined ? '' : year
    month = month === undefined ? '' : month

    let cacheManager = new CacheManager({
      resource: `/api/su/loans/compliance/yearMonth`,
      cacheKey: CacheKeys.NonCompliance(year, month),
      callback: this.getNonCompliancesCallback,
      ttlInSecs: 600,
    });
    cacheManager.getObject2(context, {}, { year: year, month: month })
  }

  getNonCompliancesCallback = (response) => {
    this.setState({
      complianceList: response.complianceList,
      filteredList: response.complianceList,
      errorList: response.errorList,
      yearMonth: response.yearMonth,
      year: response.yearMonth.year,
      month: response.yearMonth.month,
      previousYear: response.yearMonth.prevYear,
      previousMonth: response.yearMonth.prevMonth,
      nextYear: response.yearMonth.nextYear,
      nextMonth: response.yearMonth.nextMonth
    },
      this.applyFilter
    );
  };

  getPenalties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/penalties`,
      cacheKey: CacheKeys.Penalty(this.props.match.params.year, this.props.match.params.month),
      callback: this.getPenaltiesCallback,
      ttlInSecs: 60
    })
    // cacheManager.getObject2(context)
    if (!this.props.match.params.year || !this.props.match.params.month)
      cacheManager.getObject2(context, {}, {})
    else
      cacheManager.getObject2(context, {}, {
        year: this.props.match.params.year,
        month: this.props.match.params.month,
      })
  }

  getPenaltiesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      penalties: response,
      penaltyList: response.penaltyAndNonComplianceList,
      totalDsraDipInterest: response.dsraDipInterestF5,
      totalDefaultInterest: response.defaultInterestF5,
      totalDefaultInterestTax: response.defaultInterestTaxF5,
      totalDefaultInterestPlusTax: response.defaultInterestPlusTaxF5,
      month: response.month,
      year: response.year
    })
  }

  onDownloadComplianceReport = () => {
    let context = this.props.context;
    this.setState({ onDownloadComplianceReportRequested: true });

    RestApiUtils.post(
      context,
      `/api/su/loans/compliance/fileDownloadSignedUrl`,
      this.getDownloadComplianceReportCallback,
      {
        year: this.state.year,
        month: this.state.month
      }
    );
  };

  getDownloadComplianceReportCallback = (response) => {
    this.setState({ onDownloadComplianceReportRequested: false });

    if (response.errorList.length === 0) {
      const link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('Error downloading compliance report:', response.errorList);
    }
  };

  onFilterChange = (selectedOption) => {
    const selectedFilter = selectedOption.value;
    this.setState({ selectedFilter }, this.applyFilter);
  };

  onStatusChange = (selectedOption) => {
    this.setState({ selectedStatus: selectedOption.value }, this.applyFilter);
  };

  onSearchFilterChange = (event) => {
    const searchFilter = event.target.value;
    this.setState({ searchFilter }, this.applyFilter);
  };

  applyFilter() {
    const { complianceList, selectedFilter, selectedStatus, searchFilter, } = this.state;

    let filteredList = complianceList;

    // Step 1: Filter by financial/others category
    if (selectedFilter !== 'all') {
      filteredList = filteredList.map((account) => {
        const filteredLoanComplianceList = account.loanComplianceList.map((loanCompliance) => {
          const filteredComplianceCodeList = loanCompliance.complianceCodeList.filter((complianceCode) => {
            if (selectedFilter === 'financial') {
              return complianceCode.complianceCode === 'emi_default' || complianceCode.complianceCode === 'dsra_dip';
            } else if (selectedFilter === 'others') {
              return complianceCode.complianceCode !== 'emi_default' && complianceCode.complianceCode !== 'dsra_dip';
            }
            return true;
          });

          return {
            ...loanCompliance,
            complianceCodeList: filteredComplianceCodeList,
          };
        }).filter((loanCompliance) => loanCompliance.complianceCodeList.length > 0);

        return {
          ...account,
          loanComplianceList: filteredLoanComplianceList,
        };
      }).filter((account) => account.loanComplianceList.length > 0);
    }

    // Step 2: Filter by compliance clause status
    if (selectedStatus !== 'all') {
      filteredList = filteredList.map((account) => {
        const filteredLoanComplianceList = account.loanComplianceList.map((loanCompliance) => {
          const filteredComplianceCodeList = loanCompliance.complianceCodeList.map((complianceCode) => {
            const filteredClauseList = complianceCode.clauseList.filter(
              (clause) => clause.status === selectedStatus
            );

            return {
              ...complianceCode,
              clauseList: filteredClauseList,
            };
          }).filter((complianceCode) => complianceCode.clauseList.length > 0);

          return {
            ...loanCompliance,
            complianceCodeList: filteredComplianceCodeList,
          };
        }).filter((loanCompliance) => loanCompliance.complianceCodeList.length > 0);

        return {
          ...account,
          loanComplianceList: filteredLoanComplianceList,
        };
      }).filter((account) => account.loanComplianceList.length > 0);
    }

    // Step 3: Filter by search filter
    if (searchFilter) {
      const searchFilterLower = searchFilter.toLowerCase();
      filteredList = filteredList.filter((account) =>
        account.accountName.toLowerCase().includes(searchFilterLower)
      );
    }

    this.setState({ filteredList });
  }


  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.NonCompliance(this.state.year, this.state.month))
    this.setState({ filteredList: null, errorList: null, selectedFilter: 'all', selectedStatus: 'all', searchFilter: '' },
      this.getNonCompliances(this.props.context, this.state.year, this.state.month),
      this.getPenalties(this.props.context)
    )
  }
}

export default withRouter(Compliance2PageSF);
